module.exports = __webpack_public_path__ + "components/flag/static/square/ae-62dc507fe193d1d250f52fdb95dfa542.svg";